import { render, staticRenderFns } from "./PhaseBar.vue?vue&type=template&id=0a217c9a&"
import script from "./PhaseBar.vue?vue&type=script&lang=js&"
export * from "./PhaseBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports